import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { useSearchContext } from '../../../context/searchProvider'
import { themeSizes } from '../../../styles/theme'

import {
  StyledCloseButton,
  StyledInputWrapper,
  StyledEmptyOffsetDiv,
  StyledBarWrapper,
  StyledOuterWrapper,
  StyledClearButton,
  StyledModalNavBar,
} from './styles'
import { GamesList } from '../gamesList'
import { ContentWrapper } from '../../atoms/contentWrapper'
import { If } from '../../atoms/if'
import { ResponsiveContainer } from '../../atoms/responsiveContainer'
import { Text } from '../../atoms/text'
import { game_proptype } from '../../../propTypes'

import { useGamesApiData } from '../../../hooks/graphqlStaticQuery/useGamesApiData'
import { useTranslation } from '../../../context/translationProvider'
import { brandConfig } from '../../../config/brandConfig'

const SearchModal = (props) => {
  const { casinoType, customOnClose } = props
  const { game_category, title: initialTitle } =
    props.data?.search_modal_category_setup ?? {}
  const initialGames = game_category?.[0].carousel_games
  const { translate } = useTranslation()
  const { closeSearch, isSearchOpen } = useSearchContext()
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredData, setData] = useState([])

  const handleChange = (e) => setSearchTerm(e.target.value)

  const { games } = useGamesApiData()

  useEffect(() => {
    const filteredGames = searchTerm
      ? games.filter(({ title, search_keywords }) => {
          const searchTermLowerCase = searchTerm.toLowerCase()
          return (
            title.toLowerCase().includes(searchTermLowerCase) ||
            search_keywords?.some((keyword) =>
              keyword?.includes(searchTermLowerCase)
            )
          )
        })
      : []

    setData(filteredGames)
  }, [searchTerm, games])

  const onClear = () => {
    setSearchTerm('')
  }

  const onClose = () => {
    if (customOnClose) {
      customOnClose()
    } else {
      setSearchTerm('')
      closeSearch()
    }
}

  const createInput = () => (
    <StyledInputWrapper>
      <input
        placeholder={translate('navigation.searchPlaceholder')}
        autoFocus={true}
        value={searchTerm}
        onChange={handleChange}
        id="search-input"
        name="search-input"
        autoComplete="off"
        style={{ fontSize: brandConfig.fonts.text.paragraph.size.desktop }}
      />
      <StyledClearButton onClick={onClear} />
    </StyledInputWrapper>
  )

  if (!isSearchOpen) return <></>

  return (
    <StyledOuterWrapper>
      <ContentWrapper>
        <ResponsiveContainer
          sizeNumber={themeSizes.tablet}
          render={() => (
            <StyledModalNavBar>
              <StyledEmptyOffsetDiv />
              <Text>{translate('casino.search')}</Text>
              <StyledCloseButton onClick={onClose} />
            </StyledModalNavBar>
          )}
        />
        <ResponsiveContainer
          sizeNumber={themeSizes.tablet}
          render={() => <StyledBarWrapper>{createInput()}</StyledBarWrapper>}
          renderElse={() => (
            <StyledBarWrapper>
              <StyledEmptyOffsetDiv />
              {createInput()}
              <StyledCloseButton onClick={onClose} />
            </StyledBarWrapper>
          )}
          renderFallback={() => (
            <StyledBarWrapper>{createInput()}</StyledBarWrapper>
          )}
        />
        <If
          condition={searchTerm !== ''}
          render={() => (
            <GamesList
              games={filteredData}
              title={translate('search.results')}
              rows={2}
              showMore={true}
              observingValue={searchTerm}
              mobileNumOfColumns={casinoType == 'live-casino' ? 2 : 3}
            />
          )}
          renderElse={() => (
            <GamesList
              games={initialGames}
              title={initialTitle}
              rows={2}
              mobileNumOfColumns={casinoType == 'live-casino' ? 2 : 3}
            />
          )}
        />
      </ContentWrapper>
    </StyledOuterWrapper>
  )
}

SearchModal.defaultProps = {}
SearchModal.propTypes = {
  casinoType: PropTypes.string,
  customOnClose: PropTypes.func,
  data: PropTypes.shape({
    search_modal_category_setup: PropTypes.shape({
      title: PropTypes.string,
      game_category: PropTypes.arrayOf(
        PropTypes.shape({
          carousel_games: PropTypes.arrayOf(game_proptype),
        })
      ),
    }),
  }),
}

export { SearchModal }
